"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailJSResponseStatus = /** @class */ (function () {
    function EmailJSResponseStatus(httpResponse) {
        this.status = httpResponse.status;
        this.text = httpResponse.responseText;
    }
    return EmailJSResponseStatus;
}());
exports.EmailJSResponseStatus = EmailJSResponseStatus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/emailjs-com/source/models/EmailJSResponseStatus.js
// module id = 518
// module chunks = 0